import clsx from 'clsx';
import React from 'react';

const CardContent = ({ children, borderBottom, variant, className, ...props }) => {
  return (
    <div
      className={clsx(
        {
          'p-0': variant === 'default',
          'py-3': variant === 'compact',
          'py-3 px-4': variant === 'card' || variant === 'root',
          'border-b border-gray-100': borderBottom,
        },
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default CardContent;
